// extracted by mini-css-extract-plugin
module.exports = {"icon":"Help-module__icon___3Qof1","helps":"Help-module__helps___2-pbe"};